module.exports = __webpack_public_path__ + "img/p11-desc.f2bb867d.png";